import React from 'react';
import { Box, Heading } from '@wix/design-system';
import AverageRating from './AverageRating';
import { useTranslation } from '@wix/wix-i18n-config';

interface ProfileTemplatesHeaderProps {
  isMobileView: boolean;
  templatesLength: number;
  averageRating: number;
}

const ProfileTemplatesHeader: React.FC<ProfileTemplatesHeaderProps> = ({
  isMobileView,
  templatesLength,
  averageRating,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Box align="space-between">
        <Heading
          size={isMobileView ? 'medium' : 'large'}
          as="h2"
          dataHook="templates-title"
        >
          {t('profile-page-templates-section-title', { templatesLength })}
        </Heading>
      </Box>
      <AverageRating
        averageRating={averageRating}
        templatesLength={templatesLength}
      />
    </>
  );
};

export default ProfileTemplatesHeader;
